import React, { useState } from 'react';
import { H3, StackedColumn } from '../../../../../core';
import {
  Demographics,
  EmptyDemographics,
  PatientDetails,
} from '../../../../../api/models';
import { DemographicsDisplay } from './demographicsDisplay';
import { DemographicsInput } from '../../../../demographicsInput';

export interface PatientDemographicsProps {
  patientDetails?: PatientDetails;
  validate: boolean;
  onDemographicsChanged: (demographics: Demographics) => void;
}

const PatientDemographics: React.FC<PatientDemographicsProps> = (
  props: PatientDemographicsProps
) => {
  const [editMode, setEditMode] = useState<boolean>(false);

  const onEditDemographics = () => {
    setEditMode(true);
  };

  return (
    <div>
      {props.patientDetails && props.patientDetails.target ? (
        <StackedColumn>
          <H3 text="Patient information" />
          {editMode ? (
            <DemographicsInput
              target={props.patientDetails.target}
              demographics={
                props.patientDetails.demographics ?? EmptyDemographics
              }
              validate={props.validate}
              onDemographicsChanged={props.onDemographicsChanged}
            />
          ) : (
            <DemographicsDisplay
              demographics={
                props.patientDetails.demographics ?? EmptyDemographics
              }
              onEditDemographics={onEditDemographics}
            />
          )}
        </StackedColumn>
      ) : null}
    </div>
  );
};

export default PatientDemographics;
